import { Button as MuiButton } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import AppleButton from './AppleButton'
import TwitterButton from './TwitterButton'

const Button = withStyles(({ palette }) => {
  return {
    outlined: {
      color: palette.primary.dark,
      borderColor: palette.primary.main,
    },
    startIcon: {
      position: 'absolute',
      left: 20,
    },
  }
})(MuiButton)

export { AppleButton, TwitterButton, Button }
